import { useState, useEffect } from "react";
import { fetchDataFileToken } from "../../utils";
import { ServerUrl } from "../../constants";
import ModalImageViewer from "../../components/ModalImageViewer";

const AdminGaleria = () => {
  const [file, setFile] = useState(null);
  const [category, setCategory] = useState("Matte");
  const [uploadedImages, setUploadedImages] = useState([]);
  const [status, setStatus] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);

  /* ===============================
     UPLOAD
  ================================ */
    const handleUpload = () => {
        if (!file || file.length === 0 || !category.trim()) {
            setStatus('Выберите файлы и категорию');
            return;
        }

        const formData = new FormData();

        // ⬇️ ВАЖНО: ключ 'images'
        for (const f of file) {
            formData.append('images', f);
        }

        formData.append('category', category.trim());

        fetchDataFileToken(
            'picture/upload',
            'POST',
            formData,
            (response) => {
            if (response?.paths) {
                setStatus('Файлы успешно загружены');
                setUploadedImages((prev) => [...prev, ...response.paths]);
            } else {
                setStatus('Ошибка загрузки');
            }
            },
            true
        );
    };


  /* ===============================
     LOAD IMAGES BY CATEGORY
  ================================ */
  const fetchImagesByCategory = (cat) => {
    if (!cat?.trim()) {
      setUploadedImages([]);
      return;
    }

    fetchDataFileToken(`picture/${cat}`, "GET", null, (response) => {
      if (response?.pictures) {
        setUploadedImages(response.pictures);
      } else {
        setUploadedImages([]);
        console.log("не удалось получить картинки");
      }
    });
  };

  useEffect(() => {
    fetchImagesByCategory(category);
  }, [category]);

  /* ===============================
     DELETE
  ================================ */
  const handleDelete = (imgPath) => {
    if (!window.confirm("Вы уверены что хотите удалить эту картинку?"))
      return;

    fetchDataFileToken(
      "picture/delete",
      "POST",
      {
        path: imgPath,
        category,
      },
      (response) => {
        if (response?.message === "Файл успешно удален") {
          setUploadedImages((prev) =>
            prev.filter((img) => img !== imgPath)
          );
          setStatus("Картинка успешно удалена");
        } else {
          setStatus("Ошибка при удалении");
        }
      }
    );
  };

  /* ===============================
     RENDER
  ================================ */
  return (
    <div className="flex">
      {/* ===============================
          UPLOAD FORM
      ================================ */}
      <div className="sendPictureForm">
        <h2>Загрузка картинки в категорию</h2>

        <select
          className="mb-6 p-2 border rounded"
          onChange={(e) => setCategory(e.target.value)}
          value={category}
        >
          <option value="Matte">Матовые</option>
          <option value="StarrySky">Звездное небо</option>
          <option value="Print">Принт</option>
          <option value="lustrzaneSufit">зеркальный потолок</option>
          <option value="satynowe">сатиновый потолок</option>
          <option value="oswietleniem">
            Натяжные потолки с подсветкой
          </option>
        </select>

        <input
            type="file"
            multiple
            accept="image/*"
            onChange={(e) => setFile(e.target.files)}
            />


        <button onClick={handleUpload} type="button">
          Сохранить
        </button>

        <span>{status}</span>
      </div>

      {/* ===============================
          GALLERY + DELETE
      ================================ */}
      <div className="deletePictureForm">
        {uploadedImages.length > 0 ? (
          uploadedImages.map((imgPath, i) => (
            <div key={i}>
              <picture>
                <source
                  srcSet={`${ServerUrl}${imgPath}.webp`}
                  type="image/webp"
                />
                <img
                  src={`${ServerUrl}${imgPath}.jpg`}
                  alt={`Категория ${category} #${i}`}
                  className="imgesFromCategory"
                  loading="lazy"
                  onClick={() =>
                    setSelectedImage(
                      `${ServerUrl}${imgPath}.jpg`
                    )
                  }
                  style={{ cursor: "pointer" }}
                />
              </picture>

              <button onClick={() => handleDelete(imgPath)}>
                Удалить
              </button>
            </div>
          ))
        ) : (
          <p>Нет картинок для отображения</p>
        )}
      </div>

      {/* ===============================
          MODAL VIEWER
      ================================ */}
      <ModalImageViewer
        imageSrc={selectedImage}
        onClose={() => setSelectedImage(null)}
      />
    </div>
  );
};

export default AdminGaleria;
